
import './StartScreen.scss';
import store, { RootState } from "../store";
import { gameActions } from '../Game/gameSlice';
import { useAppSelector } from '../redux';
import LoadingScreen from './LoadingScreen';
import classNames from 'classnames';
import { getLocalStorage } from '../helpers/LocalStorage';
import ImageAsset from "../Components/ImageAsset";
import { useEffect, useState } from 'react';
import GameVersion from '../Components/GameVersion';

function StartScreen() {

  const [existingStore, setExistingStore] = useState(null);

  useEffect(() => {
   const localstorage = getLocalStorage();
   setExistingStore(localstorage);
}, []);

  const gameState = useAppSelector((state: RootState) => state.game);

  if (!gameState.hasGameLoaded) {
    return <LoadingScreen />;
  }

  function startGame() {
    store.dispatch(gameActions.startGame());
  }

  function showScoreboard() {
    store.dispatch(gameActions.showScoreboard());
  }

  function showHelp() {
    store.dispatch(gameActions.showHelp());
  }

  function continueGame(isContinueDisabled: boolean) {
    if (existingStore && !isContinueDisabled) {
      store.dispatch(gameActions.continueGame(Object.assign({}, existingStore)));
    }
  }

  const isContinueDisabled = !existingStore || (existingStore && !existingStore?.hasGameStarted);

  const continueClasses = classNames({
    "button-text": true,
    "disabled": isContinueDisabled
  });

  return (
    <div className="game_start-screen">
      <ImageAsset name="logo-animated.gif" />
      <div className="button-text" onClick={startGame} >New Game</div>
      <div className={continueClasses} onClick={() => continueGame(isContinueDisabled)} >Continue</div>
      <div className="button-text" onClick={showScoreboard} >Scoreboard</div>
      <div className="button-text" onClick={showHelp} >Help</div>
      <GameVersion />
    </div>
  );
}

export default StartScreen;
